<template>
    <div :style="iconStyle" class="fill-path">
        <component :is="{ ...icon }" v-if="icon" />
    </div>
</template>

<script>
    import colors from '@/helpers/colors';

    export default {
        props: {
            name: {
                type: String,
                required: true,
            },
            height: {
                type: String,
                default: '25',
            },
            width: {
                type: String,
                default: '25',
            },
            size: {
                type: String,
                default: null,
            },
            color: {
                type: String,
                default: colors.gray,
            },
        },
        data() {
            return {
                icon: null,
            };
        },
        async created() {
            try {
                this.icon = await import(`@/assets/icons/${this.name}.svg?component`);
            } catch (e) {
                console.error(e);
                console.error(`Failed to load icon: ${this.name}`);
            }
        },
        computed: {
            derivedColor() {
                if (colors[this.color]) {
                    return colors[this.color];
                }
                return this.color;
            },
            iconStyle() {
                return {
                    width: (this.size || this.width) + 'px',
                    height: (this.size || this.height) + 'px',
                    color: this.derivedColor,
                    fill: this.derivedColor,
                    display: 'inline-flex',
                };
            },
        },
    };
</script>

<style lang="scss">
    .fill-path svg > path {
        fill: inherit !important;
    }
</style>
